// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://scrollscan.com/address/0x7C6Da2C92caCe9F77274379Dc32a1eEE0B4C5FfD
export const pufETH__ETH_Exchange_Rate = '0x7C6Da2C92caCe9F77274379Dc32a1eEE0B4C5FfD';

// https://scrollscan.com/address/0x8B5947e03894cEAD4f96283cFa19d88D6bc73d8F
export const ylstETH_stETH_exchange_rate = '0x8B5947e03894cEAD4f96283cFa19d88D6bc73d8F';

// https://scrollscan.com/address/0x57bd9E614f542fB3d6FeF2B744f3B813f0cc1258
export const weETH__eETH_Exchange_Rate = '0x57bd9E614f542fB3d6FeF2B744f3B813f0cc1258';

// https://scrollscan.com/address/0x0E4d8D665dA14D35444f0eCADc82F78a804A5F95
export const STONE__ETH_Exchange_Rate = '0x0E4d8D665dA14D35444f0eCADc82F78a804A5F95';

// https://scrollscan.com/address/0xe428fbdbd61CC1be6C273dC0E27a1F43124a86F3
export const WSTETH__ETH = '0xe428fbdbd61CC1be6C273dC0E27a1F43124a86F3';

// https://scrollscan.com/address/0x6726C678feE07B25BBE67bC720728652E4129369
export const COMP__USD = '0x6726C678feE07B25BBE67bC720728652E4129369';

// https://scrollscan.com/address/0x812Ef236A7240D8d0d59d61A9E7d67C43eFDB20e
export const USDe__USD = '0x812Ef236A7240D8d0d59d61A9E7d67C43eFDB20e';

// https://scrollscan.com/address/0x9019Be7Aa8f66551E94d6508EA48856386945E80
export const STG__USD = '0x9019Be7Aa8f66551E94d6508EA48856386945E80';

// https://scrollscan.com/address/0x1AC823FdC79c30b1aB1787FF5e5766D6f29235E1
export const BNB__USD = '0x1AC823FdC79c30b1aB1787FF5e5766D6f29235E1';

// https://scrollscan.com/address/0x227a4E5E9239CAc88022DF86B1Ad9B24A7616e60
export const LINK__USD = '0x227a4E5E9239CAc88022DF86B1Ad9B24A7616e60';

// https://scrollscan.com/address/0x6bF14CB0A831078629D993FDeBcB182b21A8774C
export const ETH__USD = '0x6bF14CB0A831078629D993FDeBcB182b21A8774C';

// https://scrollscan.com/address/0x26f6F7C468EE309115d19Aa2055db5A74F8cE7A5
export const SCR__USD = '0x26f6F7C468EE309115d19Aa2055db5A74F8cE7A5';

// https://scrollscan.com/address/0x667f449F2B57C8FB3DaaB04D41A85216D83EbaCB
export const stBTC__BTC_Exchange_Rate = '0x667f449F2B57C8FB3DaaB04D41A85216D83EbaCB';

// https://scrollscan.com/address/0x16F46406457D35fc40BBAA306d8a81aa414e8482
export const uniETH__ETH_Exchange_Rate = '0x16F46406457D35fc40BBAA306d8a81aa414e8482';

// https://scrollscan.com/address/0xDf3F55B6bd57084DD4a72a41853C0a2487CB757F
export const SOL__USD = '0xDf3F55B6bd57084DD4a72a41853C0a2487CB757F';

// https://scrollscan.com/address/0x6dCa10bce66548e26DBd1FCF4E8692796BeDdd7E
export const stBTC_Proof_of_Reserves = '0x6dCa10bce66548e26DBd1FCF4E8692796BeDdd7E';

// https://scrollscan.com/address/0xB4b121ebE4DdCdFD3378b9519A101678829fE8c6
export const AVAX__USD = '0xB4b121ebE4DdCdFD3378b9519A101678829fE8c6';

// https://scrollscan.com/address/0x203322e1d15EB3Dff541a5aF0288D951c4a8d3eA
export const DAI__USD = '0x203322e1d15EB3Dff541a5aF0288D951c4a8d3eA';

// https://scrollscan.com/address/0x45c2b8C204568A03Dc7A2E32B71D67Fe97F908A9
export const L2_Sequencer_Uptime_Status_Feed = '0x45c2b8C204568A03Dc7A2E32B71D67Fe97F908A9';

// https://scrollscan.com/address/0xE9C5bedC9dfA8d758a8C2e81482c2e0623301d4D
export const ynETH__ETH_Exchange_Rate = '0xE9C5bedC9dfA8d758a8C2e81482c2e0623301d4D';

// https://scrollscan.com/address/0x3a44916dc37Bb7D73419Fc6492d6d9Dfd8e6ddf7
export const rsETH__ETH_Exchange_Rate = '0x3a44916dc37Bb7D73419Fc6492d6d9Dfd8e6ddf7';

// https://scrollscan.com/address/0x8658273E2f7bc06d3F8462703b8a733204312fF2
export const CRV__USD = '0x8658273E2f7bc06d3F8462703b8a733204312fF2';

// https://scrollscan.com/address/0x61C432B58A43516899d8dF33A5F57edb8d57EB77
export const WBTC__USD = '0x61C432B58A43516899d8dF33A5F57edb8d57EB77';

// https://scrollscan.com/address/0x78409c5b2dE2aC8ac76f45458FBaDD707e87B98a
export const LINK__ETH = '0x78409c5b2dE2aC8ac76f45458FBaDD707e87B98a';

// https://scrollscan.com/address/0x2667de5E58Ae152ce9c5EA6D1a8E051444294B82
export const DOGE__USD = '0x2667de5E58Ae152ce9c5EA6D1a8E051444294B82';

// https://scrollscan.com/address/0x439a2b573C8Ecd215990Fc25b4F547E89CF67b79
export const STETH__USD = '0x439a2b573C8Ecd215990Fc25b4F547E89CF67b79';

// https://scrollscan.com/address/0xf42e954D384247cE971d65f09a34500551942d67
export const agETH_ETH_Exchange_Rate = '0xf42e954D384247cE971d65f09a34500551942d67';

// https://scrollscan.com/address/0xCaca6BFdeDA537236Ee406437D2F8a400026C589
export const BTC__USD = '0xCaca6BFdeDA537236Ee406437D2F8a400026C589';

// https://scrollscan.com/address/0xE61Da4C909F7d86797a0D06Db63c34f76c9bCBDC
export const wstETH_stETH_Exchange_Rate = '0xE61Da4C909F7d86797a0D06Db63c34f76c9bCBDC';

// https://scrollscan.com/address/0x3fBB86e564fC1303625BA88EaE55740f3A649d36
export const RETH__ETH = '0x3fBB86e564fC1303625BA88EaE55740f3A649d36';

// https://scrollscan.com/address/0x538E0fC727ce4604e25354D082890cdb5553d33B
export const AAVE__USD = '0x538E0fC727ce4604e25354D082890cdb5553d33B';

// https://scrollscan.com/address/0xf376A91Ae078927eb3686D6010a6f1482424954E
export const USDT__USD = '0xf376A91Ae078927eb3686D6010a6f1482424954E';

// https://scrollscan.com/address/0x97acBC804c5Cd994829Bdf89A2569575B159ebD4
export const rswETH__ETH_Exchange_Rate = '0x97acBC804c5Cd994829Bdf89A2569575B159ebD4';

// https://scrollscan.com/address/0x43d12Fb3AfCAd5347fA764EeAB105478337b7200
export const USDC__USD = '0x43d12Fb3AfCAd5347fA764EeAB105478337b7200';

// https://scrollscan.com/address/0xf39adcF2e13D99818a3AE560F87Dd30c8326C278
export const AAVE_Network_Emergency_Count_Scroll = '0xf39adcF2e13D99818a3AE560F87Dd30c8326C278';

// https://scrollscan.com/address/0x7e73693088d88694146ab30f1dA5903a4489e992
export const WBTC__BTC = '0x7e73693088d88694146ab30f1dA5903a4489e992';

// https://scrollscan.com/address/0xd63624330Ed4e50dD65FeA45c08558F78a3d8abd
export const ezETH__ETH = '0xd63624330Ed4e50dD65FeA45c08558F78a3d8abd';

// https://scrollscan.com/address/0x14473e2BD405dcb5550ccA1d36da40227A6810EC
export const ynETHx__ETH_Exchange_Rate = '0x14473e2BD405dcb5550ccA1d36da40227A6810EC';

export const CHAIN_ID = 534352;
